export default __webpack_public_path__ + "static/media/map-marked-solid.9c559a51.svg";